import gql from 'graphql-tag';

export const LINE_LENGTH = 36;

export const VENUE_QUERY = gql`
  query getVenue($venueId: ID!) {
    venue: Venue(id: $venueId) {
      id
      name
      organizationId
      zip
      company {
        id
        name
        defaultCurrency
        country
      }

      location {
        id
        name
        city
        street
        zip
      }

      receiptTemplate {
        id
        name
        introLines
        bottomLines
        image {
          id
          file {
            id
            url
          }
        }
      }

      posDevices {
        id
        name
        claimed
      }
    }
  }
`;

export const USER_QUERY = gql`
  query GetUser($userId: ID) {
    User(id: $userId) {
      id
      name
      email
      phone
      address
      city
      zip
      orgNumber
    }
  }
`;
